<template>
<div>
 
  <div v-if="!goToOrder" id="data-list-thumb-view" class="data-list-container">    
    <vs-table ref="table" 
     pagination 
     :max-items="itemsPerPage" 
     search 
     :data="orders">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ orders.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : orders.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th>Order Id</vs-th>
        <vs-th sort-key="name">Customer Email</vs-th>
        <vs-th sort-key="category">Order Status</vs-th>
        <vs-th sort-key="category">Delivery Date</vs-th>
        <!-- <vs-th sort-key="product_status">Status</vs-th> -->
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr  :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
             <!-- <vs-td>
              <p class="sl no.">{{indextr + 1}}</p>
            </vs-td> -->
            <vs-td >
              <p class="order-name font-medium truncate" >{{tr.orderId}}</p>
            </vs-td>

            <vs-td>
              <p class="order-userEmail">{{ tr.email }}</p>
            </vs-td>

            <!-- <vs-td>
              <vs-chip :color="getProductStatusColor(tr.product_status)" class="product-order-status">{{ tr.product_status | title }}</vs-chip>
            </vs-td> -->

            <vs-td>
              <p class="order-status">{{ tr.status }}</p>
            </vs-td>

            <vs-td>
              <p class="order-deliveryDate" v-if="data[indextr].deliveryDate">{{ data[indextr].deliveryDate.substr(0,10)}}</p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
                <vs-button @click="manageOrder(tr)">Manage Order</vs-button>
              <!-- <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr)" /> -->
              <!-- <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" /> -->
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
  <ManageOrder v-if="goToOrder" 
  :isSidebarActive="goToOrder"
  @closeSidebar="toggleDataSidebar"
  :orderData="sidebarData"
  />
  </div>
</template>

<script>
import moduleOrderManagement from '@/store/order-management/moduleOrderManagement.js'
import ManageOrder from '@/views/pages/orders/manageOrder.vue'

export default {
  components: {
    ManageOrder
  },
  data () {
    return {
      selected: [],
      // products: [],
      itemsPerPage: 4,
      isMounted: false,
      goToOrder: false,
      addNewDataSidebar: false,
      sidebarData: {}
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    orders () {
      return this.$store.state.orders.orders
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.orders.length
    }
  },
  methods: {
    addNewData () {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    deleteData (id) {
      this.$store.dispatch('products/removeProduct', id).catch(err => { console.error(err) })
    },
    manageOrder (data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    getProductStatusColor (status) {
      if (status === 'on_hold')   return 'warning'
      if (status === 'delivered') return 'success'
      if (status === 'canceled')  return 'danger'
      return 'primary'
    },
    getPopularityColor (num) {
      if (num > 90)  return 'success'
      if (num > 70)  return 'primary'
      if (num >= 50) return 'warning'
      if (num < 50)  return 'danger'
      return 'primary'
    },
    toggleDataSidebar (val = false) {
      this.goToOrder = val
      this.addNewDataSidebar = val
    }
  },
  created () {
    if (!moduleOrderManagement.isRegistered) {
      this.$store.registerModule('orders', moduleOrderManagement)
      moduleOrderManagement.isRegistered = true
    }
    this.$store.dispatch('orders/fetchOrders')
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;


      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 10px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
            &.img-container {
              // width: 1rem;
              // background: #fff;

              span {
                display: flex;
                justify-content: flex-start;
              }

              .product-img {
                height: 110px;
              }
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
